<div class="container-fluid mt-4">
  <div *ngIf="matrixStats && matrixStats.length > 0; else noDataAlert" class="card shadow mb-4">
    <div class="card-header bg-secondary py-1">
      <!-- <h5 class="card-title mb-0 text-white">Exam Registration Statistics by Year &amp; Section</h5> -->
      <h5 class="card-title mb-0 text-white">EAF Status ({{academicYearName}})</h5>
    </div>
    <div class="card-body p-0">
      <div class="table-responsive">
        <table class="table table-bordered table-hover text-center align-middle" width="100%" cellspacing="0">
          <thead class="table-light">
            <tr>
              <th class="align-middle border-right">Year &amp; Semester</th>
              <th class="align-middle border-right">Section</th>
              <th>Total <br><span class="text-muted">(A+B) or (B+C+D)</span></th>
              <th>Eligible <br><span class="text-muted">(A)</span></th>
              <th>Not Eligible <br><span class="text-muted">(B)</span></th>
              <th>EAF Reg <br><span class="text-muted">(C)</span></th>
              <th>EAF Not Reg <br><span class="text-muted">(D)</span></th>
              <th>Not Elg &amp; Not Reg <br><span class="text-muted">(B + D)</span></th>
            </tr>
          </thead>
          <tbody>
            <ng-container *ngFor="let row of matrixStats">
              <tr *ngFor="let stats of row.sections; let first = first">
                <th *ngIf="first" [attr.rowspan]="row.sections.length" scope="row" class="font-weight-bold align-middle border-right" style="white-space: nowrap;">
                  {{ row.yearSemLabel }}
                </th>
                <td class="align-middle font-weight-bold border-right">{{ stats.sectionName }}</td>
                
                <!-- Total -->
                <td class="align-middle">
                  <a *ngIf="stats.totalStudents > 0; else emptyTmpl" href="javascript:void(0)" class="text-decoration-none fw-bold d-block text-nowrap" (click)="openModal(row.year, row.semester, stats.sectionName, 'Total')">
                    {{ stats.totalStudents }}
                  </a>
                </td>
                
                <!-- Eligible -->
                <td class="text-success align-middle">
                  <a *ngIf="stats.eligibleStudents > 0 || stats.hncEligibleStudents > 0 || stats.brcEligibleStudents > 0; else emptyTmpl" href="javascript:void(0)" class="text-success text-decoration-none fw-bold d-block text-nowrap" (click)="openModal(row.year, row.semester, stats.sectionName, 'Eligible')">
                    <ng-container *ngIf="stats.eligibleStudents > 0">{{ stats.eligibleStudents }}</ng-container>
                    <ng-container *ngIf="stats.hncEligibleStudents > 0"> + {{ stats.hncEligibleStudents }}(H)</ng-container>
                    <ng-container *ngIf="stats.brcEligibleStudents > 0"> + {{ stats.brcEligibleStudents }}(B)</ng-container>
                  </a>
                </td>
                
                <!-- Not Eligible -->
                <td class="text-danger align-middle">
                  <a *ngIf="stats.notEligibleStudents > 0; else emptyTmpl" href="javascript:void(0)" class="text-danger text-decoration-none fw-bold d-block text-nowrap" (click)="openModal(row.year, row.semester, stats.sectionName, 'Not Eligible')">
                    <!-- {{ stats.notEligibleStudents }} -->
                    <ng-container *ngIf="stats.notEligibleStudents > 0">{{ stats.notEligibleStudents }}</ng-container>
                    <ng-container *ngIf="stats.hncNotEligibleStudents > 0"> + {{ stats.hncNotEligibleStudents }}(H)</ng-container>
                    <ng-container *ngIf="stats.brcNotEligibleStudents > 0"> + {{ stats.brcNotEligibleStudents }}(B)</ng-container>
                  </a>
                </td>
                
                <!-- EAF Registered -->
                <td class="text-primary align-middle">
                  <a *ngIf="stats.eafRegistered > 0 || stats.hncRegistered > 0 || stats.brcRegistered > 0; else emptyTmpl" href="javascript:void(0)" class="text-primary text-decoration-none fw-bold d-block text-nowrap" (click)="openModal(row.year, row.semester, stats.sectionName, 'EAF Registered')">
                    <ng-container *ngIf="stats.eafRegistered > 0">{{ stats.eafRegistered }}</ng-container>
                    <ng-container *ngIf="stats.hncRegistered > 0"> + {{ stats.hncRegistered }}(H)</ng-container>
                    <ng-container *ngIf="stats.brcRegistered > 0"> + {{ stats.brcRegistered }}(B)</ng-container>
                  </a>
                </td>
                
                <!-- EAF Not Registered -->
                <td class="text-info align-middle">
                  <a *ngIf="stats.eafNotRegistered > 0 || stats.hncNotRegistered > 0 || stats.brcNotRegistered > 0; else emptyTmpl" href="javascript:void(0)" class="text-info text-decoration-none fw-bold d-block text-nowrap" (click)="openModal(row.year, row.semester, stats.sectionName, 'EAF Not Registered')">
                    <ng-container *ngIf="stats.eafNotRegistered > 0">{{ stats.eafNotRegistered }}</ng-container>
                    <ng-container *ngIf="stats.hncNotRegistered > 0"> + {{ stats.hncNotRegistered }}(H)</ng-container>
                    <ng-container *ngIf="stats.brcNotRegistered > 0"> + {{ stats.brcNotRegistered }}(B)</ng-container>
                  </a>
                </td>
                
                <!-- Not Eligible & Not Registered -->
                <td class="text-secondary align-middle">
                  <a *ngIf="stats.notEligibleAndNotRegistered > 0 || stats.hncNotEligibleAndNotRegistered > 0 || stats.brcNotEligibleAndNotRegistered > 0; else emptyTmpl" href="javascript:void(0)" class="text-secondary text-decoration-none fw-bold d-block text-nowrap" (click)="openModal(row.year, row.semester, stats.sectionName, 'Not Eligible & Not Registered')">
                    <ng-container *ngIf="stats.notEligibleAndNotRegistered > 0">{{ stats.notEligibleAndNotRegistered }}</ng-container>
                    <ng-container *ngIf="stats.hncNotEligibleAndNotRegistered > 0"> + {{ stats.hncNotEligibleAndNotRegistered }}(H)</ng-container>
                    <ng-container *ngIf="stats.brcNotEligibleAndNotRegistered > 0"> + {{ stats.brcNotEligibleAndNotRegistered }}(B)</ng-container>
                  </a>
                </td>
                
              </tr>
            </ng-container>
            <tr *ngIf="matrixStats && matrixStats.length > 0" class="table-secondary fw-bold">
              <td colspan="2" class="align-middle text-end font-weight-bold border-right">Grand Total</td>
              
              <!-- Total -->
              <td class="align-middle">
                <a *ngIf="grandTotals.totalStudents > 0; else emptyTmpl" href="javascript:void(0)" class="text-decoration-none fw-bold d-block text-nowrap" (click)="openModal(0, 'All', 'All', 'Total')">
                  {{ grandTotals.totalStudents }}
                </a>
              </td>
              
              <!-- Eligible -->
              <td class="text-success align-middle">
                <a *ngIf="grandTotals.eligibleStudents > 0 || grandTotals.hncEligibleStudents > 0 || grandTotals.brcEligibleStudents > 0; else emptyTmpl" href="javascript:void(0)" class="text-success text-decoration-none fw-bold d-block text-nowrap" (click)="openModal(0, 'All', 'All', 'Eligible')">
                  <ng-container *ngIf="grandTotals.eligibleStudents > 0">{{ grandTotals.eligibleStudents }}</ng-container>
                  <ng-container *ngIf="grandTotals.hncEligibleStudents > 0"> + {{ grandTotals.hncEligibleStudents }}(H)</ng-container>
                  <ng-container *ngIf="grandTotals.brcEligibleStudents > 0"> + {{ grandTotals.brcEligibleStudents }}(B)</ng-container>
                </a>
              </td>
              
              <!-- Not Eligible -->
              <td class="text-danger align-middle">
                <a *ngIf="grandTotals.notEligibleStudents > 0; else emptyTmpl" href="javascript:void(0)" class="text-danger text-decoration-none fw-bold d-block text-nowrap" (click)="openModal(0, 'All', 'All', 'Not Eligible')">
                  <ng-container *ngIf="grandTotals.notEligibleStudents > 0">{{ grandTotals.notEligibleStudents }}</ng-container>
                  <ng-container *ngIf="grandTotals.hncNotEligibleStudents > 0"> + {{ grandTotals.hncNotEligibleStudents }}(H)</ng-container>
                  <ng-container *ngIf="grandTotals.brcNotEligibleStudents > 0"> + {{ grandTotals.brcNotEligibleStudents }}(B)</ng-container>
                </a>
              </td>
              
              <!-- EAF Registered -->
              <td class="text-primary align-middle">
                <a *ngIf="grandTotals.eafRegistered > 0 || grandTotals.hncRegistered > 0 || grandTotals.brcRegistered > 0; else emptyTmpl" href="javascript:void(0)" class="text-primary text-decoration-none fw-bold d-block text-nowrap" (click)="openModal(0, 'All', 'All', 'EAF Registered')">
                  <ng-container *ngIf="grandTotals.eafRegistered > 0">{{ grandTotals.eafRegistered }}</ng-container>
                  <ng-container *ngIf="grandTotals.hncRegistered > 0"> + {{ grandTotals.hncRegistered }}(H)</ng-container>
                  <ng-container *ngIf="grandTotals.brcRegistered > 0"> + {{ grandTotals.brcRegistered }}(B)</ng-container>
                </a>
              </td>
              
              <!-- EAF Not Registered -->
              <td class="text-info align-middle">
                <a *ngIf="grandTotals.eafNotRegistered > 0 || grandTotals.hncNotRegistered > 0 || grandTotals.brcNotRegistered > 0; else emptyTmpl" href="javascript:void(0)" class="text-info text-decoration-none fw-bold d-block text-nowrap" (click)="openModal(0, 'All', 'All', 'EAF Not Registered')">
                  <ng-container *ngIf="grandTotals.eafNotRegistered > 0">{{ grandTotals.eafNotRegistered }}</ng-container>
                  <ng-container *ngIf="grandTotals.hncNotRegistered > 0"> + {{ grandTotals.hncNotRegistered }}(H)</ng-container>
                  <ng-container *ngIf="grandTotals.brcNotRegistered > 0"> + {{ grandTotals.brcNotRegistered }}(B)</ng-container>
                </a>
              </td>
              
              <!-- Not Eligible & Not Registered -->
              <td class="text-secondary align-middle">
                <a *ngIf="grandTotals.notEligibleAndNotRegistered > 0 || grandTotals.hncNotEligibleAndNotRegistered > 0 || grandTotals.brcNotEligibleAndNotRegistered > 0; else emptyTmpl" href="javascript:void(0)" class="text-secondary text-decoration-none fw-bold d-block text-nowrap" (click)="openModal(0, 'All', 'All', 'Not Eligible & Not Registered')">
                  <ng-container *ngIf="grandTotals.notEligibleAndNotRegistered > 0">{{ grandTotals.notEligibleAndNotRegistered }}</ng-container>
                  <ng-container *ngIf="grandTotals.hncNotEligibleAndNotRegistered > 0"> + {{ grandTotals.hncNotEligibleAndNotRegistered }}(H)</ng-container>
                  <ng-container *ngIf="grandTotals.brcNotEligibleAndNotRegistered > 0"> + {{ grandTotals.brcNotEligibleAndNotRegistered }}(B)</ng-container>
                </a>
              </td>
              
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>

  <ng-template #noDataAlert>
    <div class="alert alert-info mt-3">
      Loading statistics or no data available...
    </div>
  </ng-template>
  
  <ng-template #emptyTmpl>
    <span class="text-muted">-</span>
  </ng-template>

</div>

<!-- Modal -->
<div *ngIf="showModal" class="modal fade show d-block" tabindex="-1" style="background: rgba(0,0,0,0.5);">
  <div class="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable" style="max-width: 80%;">
    <div class="modal-content shadow">
      <div class="modal-header bg-light">
        <h5 class="modal-title">{{ modalTitle }} ({{ selectedStudents.length }})</h5>
        <button type="button" class="btn-close" aria-label="Close" (click)="closeModal()"></button>
      </div>
      <div class="modal-body p-0">
        <div class="table-responsive" *ngIf="selectedStudents.length > 0; else noData">
          <table class="table table-hover table-striped mb-0 text-sm">
            <thead class="table-dark sticky-top">
              <tr>
                <th>S.No</th>
                <th>Hall Ticket No</th>
                <th>Student Name</th>
                <th *ngIf="modalCategory !== 'Total' && modalCategory !== 'Eligible' 
                && modalCategory !== 'Not Eligible' && modalCategory !== 'EAF Registered'
                && modalCategory !== 'EAF Not Registered'
                ">Status</th>
                <th *ngIf="modalCategory !== 'Total' && hasHonoursData">Honours</th>
                <th *ngIf="modalCategory !== 'Total' && hasBrcData">BRC</th>
                <th>Student Mobile</th>
                <th>Staff Name</th>
                <th>Mentor Mobile</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let student of selectedStudents; let i = index">
                <td class="align-middle">{{ i + 1 }}</td>
                <td class="align-middle">{{ student.htNo }}</td>
                <td class="align-middle">{{ student.studentName | titlecase }}</td>
                <td class="align-middle" *ngIf="modalCategory !== 'Total' && 
                modalCategory !== 'Eligible' && modalCategory !== 'Not Eligible' &&
                modalCategory !== 'EAF Registered' && modalCategory !== 'EAF Not Registered'
                ">
                  <span *ngIf="getRegularStatus(student, modalCategory)" 
                        class="badge"
                        [ngClass]="getRegularStatus(student, modalCategory).toLowerCase() === 'fail' ? 'bg-danger' : 'bg-primary'">
                    {{ getRegularStatus(student, modalCategory) }}
                  </span>
                </td>
                <td class="align-middle" *ngIf="modalCategory !== 'Total' && hasHonoursData">
                  <span *ngIf="getHonoursStatus(student, modalCategory)" 
                        class="badge"
                        [ngClass]="getHonoursStatus(student, modalCategory).toLowerCase() === 'fail' ? 'bg-danger' : 'bg-success'">
                    {{ getHonoursStatus(student, modalCategory) }}
                  </span>
                </td>
                <td class="align-middle" *ngIf="modalCategory !== 'Total' && hasBrcData">
                  <span *ngIf="getBrcStatus(student, modalCategory)" 
                        class="badge"
                        [ngClass]="getBrcStatus(student, modalCategory).toLowerCase() === 'fail' ? 'bg-danger text-white' : 'bg-info text-dark'">
                    {{ getBrcStatus(student, modalCategory) }}
                  </span>
                </td>
                <td class="align-middle">{{student.studentMobile}}</td>
                <td class="align-middle">{{student.staffName | titlecase}}</td>
                <td class="align-middle">{{student.mentorMobile}}</td>  
              </tr>
            </tbody>
          </table>
        </div>
        <ng-template #noData>
          <div class="p-4 text-center text-muted">
            <i class="bi bi-info-circle display-4"></i>
            <p class="mt-2 text-sm">No students found in this category.</p>
          </div>
        </ng-template>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary text-sm" (click)="closeModal()">Close</button>
      </div>
    </div>
  </div>
</div>
